// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React, { useCallback } from 'react'
import { func, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reset } from 'redux-form'

// NOTE - reset is a function from redux-form which reverts the specified form
// back to its initial state.
// forms with pagination are constantly having their form initialized.
// (this is due to complex requirements of persisting pagination when leaving/returning to pages
// and hiding the pagination when the form's not pristine)
// So, if you want to 'clear' a <SearchAndSelect /> with pagination,
// be sure to pass a clearForm func which reverts it to its true initial state.
// See ../../PathDb/components/helpers/clearForm for an example

const Clear = props => {
  const {
    clearForm,
    idRoot,
    reset,
    sourceForm,
  } = props

  const onClick = useCallback((
    clearForm
      ? () => clearForm(sourceForm)
      : () => reset(sourceForm)
  ), [])

  return (
    <a
      id={`${idRoot}clear`}
      className={'btn search-button big-button bg-pink text-white display-block'}
      onClick={onClick}>
      {'Clear'}
    </a>
  )
}

Clear.propTypes = {
  clearForm: func,
  idRoot: string.isRequired,
  reset: func.isRequired,
  sourceForm: string.isRequired,
}

// bind the clearForm func to dispatch here.
// if clearForm is undefined, within <Clear />
// it will also be undefined.
const mapDispatchToProps = (dispatch, { clearForm }) => (
  bindActionCreators({
    clearForm,
    reset,
  }, dispatch)
)

export default connect(
  null,
  mapDispatchToProps,
)(Clear)
